export default __webpack_public_path__ + "static/media/Green_Dot.2f14b0e9.svg";